import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';

export const ImgWrapper = styled.div`
  display: block;
  overflow: hidden;
  padding: 56.25% 0 0 0;
  position: relative;
  width: 500px;
`;

export const Img = styled.img`
  position: absolute;
  top: 0;
  width: 100%;
  margin: 10px 0px;
`;

const styles = {
  emptyContainer: {
    alignItems: 'center',
    paddingBottom: '40px'
  },
  image: {
    objectFit: 'contain',
  },
};

export const useStyles = makeStyles(styles);
